/* eslint-disable no-unused-vars */
import { useEffect, forwardRef, useImperativeHandle } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

//project import
import { useColumnOrder, useTable, useGroupBy, useExpanded } from 'react-table';
import update from 'immutability-helper';
import
{
   DraggableHeader,
   DragPreview
} from 'components/third-party/ReactTable';

import
{
   faArrowRight,
   faArrowDown
} from '@fortawesome/pro-light-svg-icons';

//MUI
import
{
   Alert,
   Stack,
   Table,
   TableBody,
   TableCell,
   TableContainer,
   TableHead,
   TableRow,
   TableSortLabel,
   Typography
} from '@mui/material';


const ReactTable = forwardRef((props, ref) =>
{
   const theme = useTheme();

   const {
      columns,
      data,
      initialState,
      setInitialColumnsOrder,
      getTrProps,
      onRowClick,
      onCellClick,
      header = false,
      footer,
      orderAsc,
      groupByField = null,
      onSortChange,
      onGroupByChange,
      sx
   } = props

   const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      // eslint-disable-next-line no-unused-vars
      setGroupBy,
      prepareRow,
      // @ts-ignore
      setColumnOrder,
      setHiddenColumns,
      visibleColumns,
      // eslint-disable-next-line no-unused-vars
      state: { groupBy, columnOrder, hiddenColumns },
   } = useTable(
      {
         columns,
         data,
         getTrProps,
         initialState
      },
      useColumnOrder,
      useGroupBy,
      useExpanded,
   );

   useImperativeHandle(ref, () => ({
      hiddenColumns: () => hiddenColumns,
      setHiddenColumns: (nuovoValore) => setHiddenColumns(nuovoValore),
      columnOrder: () => columnOrder,
      setColumnOrder: (nuovoValore) => setColumnOrder(nuovoValore),
   }));

   useEffect(() =>
   {
      setGroupBy(groupByField);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [data, groupByField]);

   useEffect(() =>
   {
      // @ts-ignore
      const newColumnOrder = visibleColumns.map((column) => column.id);
      setColumnOrder(newColumnOrder);
      setInitialColumnsOrder(newColumnOrder);

      // eslint-disable-next-line
   }, [hiddenColumns]);

   // useEffect(() =>
   // {
   //    setHiddenColumns(hiddenColumns);
   // }, [hiddenColumns, setHiddenColumns]);

   const reorder = (item, newIndex) =>
   {
      const { index: currentIndex } = item;

      const dragRecord = columnOrder[currentIndex];

      const newColumnOrder = update(columnOrder, {
         $splice: [
            [currentIndex, 1, columnOrder[newIndex]], // Rimuove l'elemento in index1 e inserisce quello in index2
            [newIndex, 1, columnOrder[currentIndex]], // Rimuove l'elemento in index2 e inserisce quello in index1
         ]
      });

      setColumnOrder(newColumnOrder);
      setInitialColumnsOrder(newColumnOrder);
   }

   return (
      <>
         <Table
            size="small"
            sx={{
               '& td': {
                  fontSize: '.75rem'
               },
               ...sx
            }}
            {...getTableProps()}
         >
            {
               header && (
                  <TableHead>
                     {headerGroups.map((headerGroup, i) => (
                        <TableRow
                           key={i}
                           {...headerGroup.getHeaderGroupProps()}
                        >
                           {headerGroup.headers.map((column, index) =>
                           {
                              const draggable = column?.draggable ?? true;
                              return (
                                 <TableCell
                                    key={index}
                                    sx={{
                                       whiteSpace: 'nowrap',
                                       cursor: draggable ? 'move' : 'pointer',
                                       ...column.sx
                                    }}
                                    {...column.getHeaderProps([{ className: column.className }])}
                                 >
                                    {
                                       !column?.hiddenLabel && (
                                          draggable ? (
                                             <DraggableHeader reorder={reorder} key={column.id} column={column} index={index}>
                                                <Stack
                                                   direction="row"
                                                   alignItems={'center'}
                                                   className={column.className}
                                                >
                                                   <Typography
                                                      variant="body2"
                                                      component={'div'}
                                                      sx={{
                                                         lineHeight: 1,
                                                         fontWeight: 700,
                                                         textDecoration: column.aggregate ? 'underline' : 'none',
                                                         textUnderlineOffset: 3,
                                                         textDecorationThickness: 2,
                                                         textDecorationColor: column.isGrouped ? 'primary.main' : '#cccccc',
                                                         cursor: 'pointer'
                                                      }}
                                                      // {...column.getGroupByToggleProps()}
                                                      onClick={() =>
                                                      {
                                                         column.aggregate && onGroupByChange(groupBy.includes(column.id) ? [] : [column.id]);
                                                      }}
                                                   >
                                                      {column.render('Header')}
                                                   </Typography>
                                                   {
                                                      column.sortable && (
                                                         <TableSortLabel
                                                            direction={orderAsc ? 'asc' : 'desc'}
                                                            onClick={() => onSortChange(column.id, orderAsc, column?.related)}
                                                            active
                                                         >
                                                         </TableSortLabel>
                                                      )
                                                   }
                                                </Stack>
                                             </DraggableHeader>
                                          ) : (
                                             <Stack
                                                direction="row"
                                                alignItems={'center'}
                                                className={column.className}
                                             >
                                                <Typography
                                                   variant="body2"
                                                   sx={{
                                                      lineHeight: 1,
                                                      fontWeight: 700,
                                                      textDecoration: column.aggregate ? 'underline' : 'none',
                                                      textUnderlineOffset: 3,
                                                      textDecorationThickness: 2,
                                                      textDecorationColor: column.isGrouped ? 'primary.main' : '#cccccc',
                                                      cursor: 'pointer'
                                                   }}
                                                   // {...column.getGroupByToggleProps()}
                                                   onClick={() =>
                                                   {
                                                      column.aggregate && onGroupByChange(groupBy.includes(column.id) ? [] : [column.id]);
                                                   }}
                                                >
                                                   {column.render('Header')}
                                                </Typography>
                                                {
                                                   column.sortable && (
                                                      <TableSortLabel
                                                         direction={orderAsc ? 'asc' : 'desc'}
                                                         onClick={() => onSortChange(column.id, orderAsc, column?.related)}
                                                         active
                                                      >
                                                      </TableSortLabel>
                                                   )
                                                }
                                             </Stack>
                                          )
                                       )
                                    }
                                 </TableCell>
                              )
                           })}
                        </TableRow>
                     ))}
                  </TableHead>
               )
            }
            <TableBody {...getTableBodyProps()}>
               {
                  !rows.length && (
                     <TableRow>
                        <TableCell
                           colSpan={columns.length}
                           align="center"
                           sx={{
                              '&.MuiTableCell-root:first-of-type': {
                                 p: 0
                              }
                           }}
                        >
                           <Alert severity="info">Nessun risultato trovato</Alert>
                        </TableCell>
                     </TableRow>
                  )
               }
               {rows.map((row, i) =>
               {
                  //console.log('ROW', row);
                  prepareRow(row);
                  return (
                     <TableRow
                        sx={{
                           '&:last-child td, &:last-child th': {
                              border: 0
                           },
                           height: '2.5rem',
                           cursor: 'pointer',
                           '& td': {
                              px: '.75rem'
                           }
                        }}
                        onClick={(event) => onRowClick(event, row?.original)}
                        {...row.getRowProps(getTrProps(row))}
                        key={i}
                     >
                        {row.cells.map((cell, i) => (
                           <TableCell
                              key={i}
                              onClick={(event) => onCellClick(event, row, cell.column)}
                              {...cell.getCellProps([{
                                 className: cell.column.className, sx: {
                                    backgroundColor: cell.isGrouped
                                       ? theme.palette.success.lighter
                                       : cell.isAggregated
                                          ? theme.palette.warning.lighter
                                          : cell.isPlaceholder
                                             ? theme.palette.error.lighter
                                             : 'white',
                                    ...cell.column.sx
                                 }
                              }])}

                           >
                              {cell.isGrouped ? (
                                 <>
                                    <span {...row.getToggleRowExpandedProps()}>
                                       <FontAwesomeIcon icon={row.isExpanded ? faArrowDown : faArrowRight} />
                                    </span>&nbsp;&nbsp;
                                    {cell.render('Cell')} ({row.subRows.length})
                                 </>
                              ) : cell.isAggregated ? (
                                 cell.render('Aggregated')
                              ) : cell.isPlaceholder ? null : (
                                 cell.render('Cell')
                              )}
                           </TableCell>
                        ))}
                     </TableRow>
                  );
               })}
            </TableBody>
            {
               footer && (footer)
            }
         </Table>
      </>
   )
});

ReactTable.propTypes = {
   columns: PropTypes.array,
   data: PropTypes.array,
   getTrProps: PropTypes.func,
   initialState: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
   setInitialColumnsOrder: PropTypes.func,
   onSort: PropTypes.func,
   onRowClick: PropTypes.func,
   onCellClick: PropTypes.func,
   header: PropTypes.bool,
   footer: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
   orderAsc: PropTypes.bool,
   groupByField: PropTypes.array,
   onSortChange: PropTypes.func,
   onGroupByChange: PropTypes.func,
   sx: PropTypes.object
};


const ResourceTable = forwardRef((props, ref) =>
{

   const {
      data,
      columns,
      getTrProps = () => { },
      initialState = {},
      setInitialColumnsOrder = () => { },
      onSort = () => { },
      onRowClick = () => { },
      onCellClick = () => { },
      header = true,
      footer,
      orderAsc = true,
      groupByField = [],
      onSortChange = () => { },
      onGroupByChange = () => { },
      sx
   } = props;


   return (
      <TableContainer>
         {
            data?.results && (
               <>
                  <ReactTable
                     columns={columns}
                     data={data?.results}
                     getTrProps={getTrProps}
                     initialState={initialState}
                     setInitialColumnsOrder={setInitialColumnsOrder}
                     onSort={onSort}
                     groupByField={groupByField}
                     onRowClick={onRowClick}
                     onCellClick={onCellClick}
                     header={header}
                     footer={footer}
                     orderAsc={orderAsc}
                     onSortChange={onSortChange}
                     onGroupByChange={onGroupByChange}
                     sx={sx}
                     ref={ref}
                  />
                  <DragPreview />
               </>
            )
         }
      </TableContainer>
   )
});

ResourceTable.propTypes = {
   columns: PropTypes.array,
   data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
   getTrProps: PropTypes.func,
   initialState: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
   setInitialColumnsOrder: PropTypes.func,
   onSort: PropTypes.func,
   onRowClick: PropTypes.func,
   onCellClick: PropTypes.func,
   header: PropTypes.bool,
   footer: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
   paginationProps: PropTypes.object,
   orderAsc: PropTypes.bool,
   groupByField: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
   onSortChange: PropTypes.func,
   onGroupByChange: PropTypes.func,
   sx: PropTypes.object
};

export default ResourceTable;